import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { formatLabel, formatList } from '../utils/japanese-punctuation';

@Pipe({ name: 'localeLabel', standalone: true, pure: false })
export class LocaleLabelPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(
    value: string | null | undefined,
    labelValue?: string | number | null,
  ): string {
    return formatLabel(
      value ?? '',
      this.translocoService.getActiveLang(),
      labelValue ?? undefined,
    );
  }
}

/** ["A", "B"] → "A, B" / "A、B" */
@Pipe({ name: 'localeList', standalone: true, pure: false })
export class LocaleListPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(value: readonly string[] | null | undefined): string {
    return formatList(value ?? [], this.translocoService.getActiveLang());
  }
}
